{
  "list": {
    "intro": "「ポケモン Rank A」「新入荷」のように、お店で商品をまとめて見せるページです。",
    "new": "コレクションを作る",
    "search": "コレクションを検索",
    "show_trash": "削除したものを表示（30日）",
    "empty": "コレクションがまだありません",
    "empty_hint": "カードを自分で選ぶか、条件で作れます。",
    "trash_empty": "30日以内に削除したものはありません",
    "label": "コレクション",
    "type_manual": "手で選ぶ",
    "type_smart": "条件で自動",
    "count_one": "{{count}} 点",
    "count_other": "{{count}} 点",
    "published": "お店に表示中",
    "hidden": "非表示",
    "restore": "元に戻す",
    "restored": "「{{title}}」を元に戻しました"
  },
  "new": {
    "title": "どちらのコレクションにしますか？",
    "hint": "商品はあとで変えられますが、種類は変えられません。",
    "manual": "カードを自分で選ぶ",
    "manual_hint": "検索して追加し、好きな順番に並べます。",
    "smart": "条件で自動",
    "smart_hint": "例：ポケモン・Rank A・¥10,000 以上 — 新しいカードも自動で入ります。"
  },
  "edit": {
    "new_manual": "新しいコレクション（手で選ぶ）",
    "new_smart": "新しいコレクション（条件で自動）",
    "untitled": "コレクション",
    "manual_intro": "カードを追加してドラッグで並べます。「保存」を押すまで送信されません。",
    "smart_intro": "条件に合う商品が自動で入ります。下の件数はシステムが数えたものです。",
    "basics": "名前と説明",
    "title_label": "名前",
    "title_required": "名前を入れてください",
    "description_label": "説明",
    "description_hint": "コレクションページの上に表示されます。空行で段落を分けます。",
    "publish_now": "すぐにお店に表示する",
    "products_title": "商品と並び順",
    "rules_title": "条件",
    "sort_label": "お店での並び順",
    "sort_hint": "お客様に見える順番",
    "sort": {
      "manual": "自分で決めた順番",
      "created_desc": "新しい順",
      "price_asc": "安い順",
      "price_desc": "高い順",
      "title_asc": "名前 A → Z",
      "title_desc": "名前 Z → A",
      "best_selling": "よく売れている順"
    },
    "pictures": "画像",
    "hero_desktop": "トップ画像（パソコン）",
    "hero_mobile": "トップ画像（スマホ）",
    "languages": "ほかの言語の名前と説明",
    "layout_label": "ページのレイアウト",
    "layout_hint": "標準のままなら空欄",
    "create": "コレクションを作る",
    "save": "保存",
    "saved": "「{{title}}」を保存しました",
    "show": "お店に表示",
    "hide": "お店から隠す",
    "now_shown": "お店に表示しました",
    "now_hidden": "お店から隠しました",
    "delete": "削除",
    "delete_title": "このコレクションを削除しますか？",
    "delete_consequence": "ページがお店から消えます。商品はそのままです。30日以内なら元に戻せます。",
    "deleted": "コレクションを削除しました"
  },
  "manual": {
    "add_label": "商品を追加",
    "search_placeholder": "名前・商品コード・鑑定番号",
    "results": "検索結果",
    "no_results": "見つかりません",
    "add": "追加",
    "add_named": "{{title}} を追加",
    "inside": "追加済み",
    "empty": "まだ商品がありません — 上で検索して「追加」を押してください。",
    "order_hint": "⠿ をドラッグ、▲▼ ボタン、またはスペースで持ち上げて矢印キーで移動。",
    "list_label": "このコレクションの商品",
    "remove": "{{title}} を外す",
    "removed": "「{{title}}」を外しました",
    "loading": "読み込み中…"
  },
  "rules": {
    "match_legend": "商品が合う条件",
    "match": {
      "all": "すべての条件",
      "any": "どれか1つの条件"
    },
    "list_label": "条件",
    "row_label": "条件 {{n}}",
    "field_label": "何を（条件 {{n}}）",
    "op_label": "どのように（条件 {{n}}）",
    "pick_field": "選んでください…",
    "remove": "条件 {{n}} を消す",
    "add": "条件を追加",
    "and": "〜",
    "from": "から",
    "to": "まで",
    "relative": "過去 … 日以内",
    "days_placeholder": "日数",
    "set_placeholder": "セットコード（例：SV2a）",
    "list_placeholder": "カンマ区切りで入力",
    "attribute": "追加情報：{{name}}",
    "fields": {
      "game": "ゲーム",
      "set": "セット",
      "product_type": "種類",
      "raw_rank": "Rank（A〜D、カード）",
      "grading_company": "鑑定会社",
      "grade": "グレード（鑑定品）",
      "price": "価格（¥・税込）",
      "tag": "タグ",
      "category": "カテゴリ",
      "vendor": "メーカー",
      "rarity": "レアリティ",
      "language": "カードの言語",
      "availability": "在庫あり",
      "status": "状態",
      "created_at": "登録日",
      "published_at": "販売開始日",
      "consignor": "委託品",
      "title": "名前",
      "condition_type": "カード／鑑定品／未開封",
      "compare_at_status": "参考価格の確認"
    },
    "ops": {
      "eq": "が",
      "neq": "ではない",
      "in": "のどれか",
      "not_in": "のどれでもない",
      "contains": "を含む",
      "starts_with": "で始まる",
      "gt": "より大きい",
      "gte": "以上",
      "lt": "より小さい",
      "lte": "以下",
      "between": "の間",
      "is_true": "はい",
      "is_false": "いいえ"
    },
    "ops_date": {
      "gt": "より後",
      "gte": "以降",
      "lt": "より前",
      "lte": "以前"
    },
    "ops_availability": {
      "is_true": "在庫あり",
      "is_false": "売り切れ"
    },
    "ops_consignor": {
      "is_true": "委託品",
      "is_false": "店の商品"
    },
    "status": {
      "active": "販売中",
      "draft": "下書き",
      "archived": "アーカイブ"
    },
    "condition": {
      "raw": "カード",
      "graded": "鑑定品",
      "sealed": "未開封"
    },
    "compare_at": {
      "verified": "確認済み",
      "unverified": "未確認"
    },
    "problem": {
      "field_required": "何を調べるか選んでください",
      "operator_required": "どのように調べるか選んでください",
      "value_required": "値を入れてください",
      "value_invalid": "この値は使えません — 確認してください",
      "invalid": "この条件は使えません — 確認してください",
      "unknown_field": "この条件は使えません",
      "operator_not_allowed": "この「どのように」は合いません",
      "field_not_enabled": "まだ使えません"
    }
  },
  "preview": {
    "title": "いま条件に合う商品",
    "waiting": "条件を入れると件数が出ます。",
    "counting": "数えています…",
    "count_one": "{{count}} 点が該当",
    "count_other": "{{count}} 点が該当",
    "error": "件数を出せませんでした。もう一度お試しください。",
    "fix_rows": "直す必要のある条件があります（赤い印）。"
  }
}
